import type { CSSProperties } from 'react';

export const getHeaderBackgroundStyle = (isOpenChat: boolean, isMobile: boolean): CSSProperties => {
  if (isOpenChat && isMobile) {
    return {
      backdropFilter: 'blur(14px)',
      WebkitBackdropFilter: 'blur(14px)'
    };
  }
  return {
    background: isMobile
      ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.80) -15.5%, rgba(0, 0, 0, 0.60) 46.06%, rgba(0, 0, 0, 0) 100%)'
      : 'linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0) 100%)'
  };
};
